import { useQuery } from '@grandvisionhq/graphql';
import { GET_PREFERRED_STORE_CODE } from '../../operations/queries/get-preferred-store-code.js';

const useGetPreferredStoreCode = (onError)=>{
    var ref, ref1;
    const query = useQuery(GET_PREFERRED_STORE_CODE, {
        onError (error) {
            onError === null || onError === void 0 ? void 0 : onError(error, 'stores.storeDetailsRoot.preferredStoreFetch.error');
        }
    });
    var ref2;
    return {
        data: (ref2 = (ref = query.data) === null || ref === void 0 ? void 0 : (ref1 = ref.me) === null || ref1 === void 0 ? void 0 : ref1.preferredStore) !== null && ref2 !== void 0 ? ref2 : null,
        loading: query.loading,
        error: query.error
    };
};
var useGetPreferredStoreCode$1 = useGetPreferredStoreCode;

export { useGetPreferredStoreCode$1 as default };
//# sourceMappingURL=use-get-preferred-store-code.js.map
